import { render, staticRenderFns } from "./stakeholderManagement.vue?vue&type=template&id=014ff850&scoped=true&"
import script from "./stakeholderManagement.vue?vue&type=script&lang=js&"
export * from "./stakeholderManagement.vue?vue&type=script&lang=js&"
import style0 from "./stakeholderManagement.vue?vue&type=style&index=0&id=014ff850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ff850",
  null
  
)

export default component.exports